var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectIdNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 101,
    viewBox: "0 0 109 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27651_4104)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7329 10.0525L14.7656 28.2431C8.77329 30.0311 5.36493 36.3382 7.15285 42.3306L19.1772 82.631C20.9651 88.6233 27.2723 92.0317 33.2646 90.2438L94.2319 72.0531C100.224 70.2652 103.633 63.958 101.845 57.9656L89.8204 17.6652C88.0324 11.6729 81.7253 8.26453 75.7329 10.0525Z",
    fill: "url(#paint0_linear_27651_4104)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.7533 10.0482L14.8997 28.205C8.91851 29.9896 5.37286 36.3657 6.84481 41.299L8.84825 48.0159C10.9254 54.9763 8.43196 50.3908 14.938 49.0389L92.2944 25.9583L91.3858 22.9131L89.2484 15.7496C87.7765 10.8162 81.7345 8.26363 75.7533 10.0482Z",
    fill: "url(#paint1_linear_27651_4104)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.389 65.929C42.6692 64.6519 45.1038 60.1468 43.8267 55.8665C42.5496 51.5863 38.0445 49.1517 33.7642 50.4288C29.484 51.7059 27.0494 56.211 28.3265 60.4913C29.6036 64.7715 34.1087 67.2061 38.389 65.929Z",
    fill: "url(#paint2_radial_27651_4104)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5362 64.6406L31.4458 68.8447C29.4157 69.4504 28.4041 72.0667 29.1863 74.6883L30.1306 77.8529C30.9128 80.4746 33.1926 82.1088 35.2227 81.5031L49.313 77.299C51.3431 76.6933 52.3547 74.077 51.5725 71.4554L50.6282 68.2908C49.846 65.6691 47.5662 64.0349 45.5362 64.6406Z",
    fill: "#3455C9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7293 38.3179L56.3124 46.7966C54.8856 47.2223 54.0741 48.724 54.4998 50.1507C54.9255 51.5775 56.4272 52.389 57.8539 51.9633L86.2709 43.4846C87.6977 43.0589 88.5092 41.5572 88.0835 40.1304C87.6578 38.7037 86.1561 37.8922 84.7293 38.3179Z",
    fill: "#7EA0FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4271 47.3599L59.0101 55.8386C57.5834 56.2643 56.7719 57.766 57.1975 59.1927C57.6232 60.6195 59.125 61.431 60.5517 61.0053L88.9687 52.5266C90.3954 52.1009 91.2069 50.5992 90.7812 49.1724C90.3555 47.7457 88.8538 46.9342 87.4271 47.3599Z",
    fill: "#7EA0FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1243 56.4019L61.7074 64.8806C60.2806 65.3063 59.4691 66.808 59.8948 68.2347C60.3205 69.6615 61.8222 70.473 63.249 70.0473L91.6659 61.5686C93.0927 61.1429 93.9042 59.6412 93.4785 58.2144C93.0528 56.7877 91.5511 55.9762 90.1243 56.4019Z",
    fill: "#7EA0FF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27651_4104)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3884 17.7998H23.7652C17.5118 17.7998 12.4424 22.8692 12.4424 29.1226V71.1786C12.4424 77.432 17.5118 82.5014 23.7652 82.5014H87.3884C93.6417 82.5014 98.7111 77.432 98.7111 71.1786V29.1226C98.7111 22.8692 93.6417 17.7998 87.3884 17.7998Z",
    fill: "url(#paint3_linear_27651_4104)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.4094 17.7998H23.9048C17.6631 17.7998 12.4425 22.896 12.4425 28.0442L12.4418 35.0536C12.4422 42.3173 11.3639 37.2103 17.9848 37.775H98.7111V34.5971V27.1216C98.7111 21.9733 93.6512 17.7998 87.4094 17.7998Z",
    fill: "url(#paint4_linear_27651_4104)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6277 60.6646C40.0944 60.6646 43.7154 57.0437 43.7154 52.577C43.7154 48.1102 40.0944 44.4893 35.6277 44.4893C31.161 44.4893 27.54 48.1102 27.54 52.577C27.54 57.0437 31.161 60.6646 35.6277 60.6646Z",
    fill: "url(#paint5_radial_27651_4104)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8453 61.4736H28.1411C26.0226 61.4736 24.3052 63.6915 24.3052 66.4273V69.7298C24.3052 72.4657 26.0226 74.6835 28.1411 74.6835H42.8453C44.9637 74.6835 46.6811 72.4657 46.6811 69.7298V66.4273C46.6811 63.6915 44.9637 61.4736 42.8453 61.4736Z",
    fill: "#3455C9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9284 47.4541H58.2735C56.7846 47.4541 55.5776 48.6611 55.5776 50.15C55.5776 51.6389 56.7846 52.8459 58.2735 52.8459H87.9284C89.4173 52.8459 90.6243 51.6389 90.6243 50.15C90.6243 48.6611 89.4173 47.4541 87.9284 47.4541Z",
    fill: "#7EA0FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9284 56.8896H58.2735C56.7846 56.8896 55.5776 58.0966 55.5776 59.5855C55.5776 61.0745 56.7846 62.2814 58.2735 62.2814H87.9284C89.4173 62.2814 90.6243 61.0745 90.6243 59.5855C90.6243 58.0966 89.4173 56.8896 87.9284 56.8896Z",
    fill: "#7EA0FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_27651_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9284 66.3262H58.2735C56.7846 66.3262 55.5776 67.5332 55.5776 69.0221C55.5776 70.511 56.7846 71.718 58.2735 71.718H87.9284C89.4173 71.718 90.6243 70.511 90.6243 69.0221C90.6243 67.5332 89.4173 66.3262 87.9284 66.3262Z",
    fill: "#7EA0FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27651_4104",
    x: 2.36381,
    y: 9.57715,
    width: 104.27,
    height: 89.7695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.31344
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27651_4104",
    x: 23.6734,
    y: 46.8538,
    width: 24.8066,
    height: 24.8066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27651_4104",
    x: 26.7652,
    y: 63.4363,
    width: 27.2285,
    height: 21.4277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_27651_4104",
    x: 52.23,
    y: 37.1267,
    width: 38.1235,
    height: 18.1845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_27651_4104",
    x: 54.9278,
    y: 46.1687,
    width: 38.1235,
    height: 18.1845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_27651_4104",
    x: 57.625,
    y: 55.2107,
    width: 38.1235,
    height: 18.1845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_27651_4104",
    x: 8.12895,
    y: 17.7998,
    width: 94.8954,
    height: 73.328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.31344
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_27651_4104",
    x: 23.2266,
    y: 41.2542,
    width: 24.8022,
    height: 24.8027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15672
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_27651_4104",
    x: 22.1485,
    y: 60.3953,
    width: 26.6894,
    height: 17.5234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_27651_4104",
    x: 53.4209,
    y: 46.3757,
    width: 39.3603,
    height: 9.70504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_27651_4104",
    x: 53.4209,
    y: 55.8113,
    width: 39.3603,
    height: 9.70504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_27651_4104",
    x: 53.4209,
    y: 65.2478,
    width: 39.3603,
    height: 9.70504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07836
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27651_4104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27651_4104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27651_4104",
    x1: 3.91553,
    y1: 31.4805,
    x2: 22.4145,
    y2: 93.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27651_4104",
    x1: 4.06971,
    y1: 31.4363,
    x2: 9.78087,
    y2: 50.5777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D7BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3159C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27651_4104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1009.14 519.011) rotate(-16.6134) scale(889.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3455C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27651_4104",
    x1: 12.4424,
    y1: 17.7998,
    x2: 12.4424,
    y2: 82.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27651_4104",
    x1: 12.6031,
    y1: 17.7998,
    x2: 12.6031,
    y2: 37.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D7BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3159C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_27651_4104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(836.309 772.382) scale(889.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3455C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27651_4104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.5822,
    height: 77.6419,
    fill: "white",
    transform: "translate(0 25.8984) rotate(-16.6134)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27651_4104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.5822,
    height: 77.6419,
    fill: "white",
    transform: "translate(10.2866 11.3301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIdNew);
export default __webpack_public_path__ + "static/media/ConnectIdNew.70e1bd6f3dcbe09a439f9bfa07c025da.svg";
export { ForwardRef as ReactComponent };